<!--接口管理-->
<template>
  <Card dis-hover class="contentArea" style="position: relative">
    <packageTable
      tableName="download"
      ref="contentBaseRef"
      class="contentBaseRef"
      :tableData="tableData"
      :columnsData="columnsData"
      :loading="tableLoading"
      :tabletotallen="tabletotallen"
      :border="border"
      :stripe="stripe"
      :showSearchBtn="false"
      rowKey="area_name"
      :showSearch="false"
      :tablePageSize="reqBase.page_size"
      @handleLoadData="handleLoadData"
      @pageonChange="pageonChange"
      @pageSizeChange="pageSizeChange"
      @showSearchParel="showSearchParel"
      @refreshBtn="init"
    >
      <template slot="search">
        <Col span="6">
          <FormItem :label="this.$t('devicelist.region')">
            <Select v-model="form_filter.country_code" filterable>
              <Option
                v-for="(item, i) in statusData3"
                :key="i"
                :value="item.value"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="6">
          <Button
            v-for="(item, index) in topButtonList"
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            >{{ item.name }}</Button
          >
        </Col>
      </template>
      <template slot="headLeft">
        <Tooltip
          v-for="(item, index) in topButtonList1"
          :key="index"
          :content="item.name"
          placement="bottom"
        >
          <Button
            :type="item.type"
            style="margin-right: 5px"
            @click="item.method"
            :key="index"
            :icon="item.icon"
          ></Button>
        </Tooltip>
      </template>
    </packageTable>
  </Card>
</template>

<script>
import packageTableMixins from "@/mixins/packageTableMixins.js";
import { area_list } from "@/api/jingxiaoshang";
import axios from "@/libs/api.request";
import config from "@/config";
import { get_table_data, download_data, del_download } from "@/api/chuku";
export default {
  name: "areaClass",
  mixins: [packageTableMixins],
  data() {
    return {
      cateList: [],
      nodeList: [],
      showSearchMore: false,
      form_filter: {
        cate_name: null,
        country_code: localStorage.getItem("country_code")?localStorage.getItem("country_code"):"xciot-prod-cnsz",
      },
      //共用的右侧添加按钮
      topButtonList1: [
        // {
        //   name: this.$t("add"),
        //   icon: "ios-add",
        //   type: "primary",
        //   method: this.add,
        // },
        // {
        //   name: this.$t("refresh"),
        //   icon: "ios-refresh",
        //   type: "primary",
        //   method: this.init,
        // },
      ],
      statusData3: [
        { value: "xciot-prod-cnsz", name: this.$t("Changelang.中国") },
        { value: "xciot-prod-hk", name: this.$t("Changelang.香港") },
        { value: "xciot-prod-us2", name: this.$t("美国") },
        { value: "xciot-prod-eu", name: this.$t("Changelang.欧洲") },
      ],
      topButtonList: [
        {
          name: this.$t("query"),
          type: "primary",
          method: this.search,
        },
        {
          name: this.$t("reset"),
          type: "error",
          method: this.reset,
        },
      ],

      searchReq: {
        mods: [],
      },
      tableData: [],
      columnsData: [
        // {
        //   title: this.$t("serialnumber"),
        //   key: "id",
        //   align: "center",
        //   width: 80,
        // },
        {
          title: this.$t("filename"),
          key: "file_url",
          align: "left",
          minWidth: 120,
          tree: true,
        },
        {
          title: this.$t("alarmmenu.status"),
          key: "status",
          align: "left",
          minWidth: 120,
          tree: true,
          render: (h, { row }) => {
            if (row.status === 1) {
              return h("div", this.$t("fileCeateing"));
            } else if (row.status === 2) {
              return h("div", this.$t("fileCeated"));
            }
          },
        },
        {
          title: this.$t("createtime"),
          key: "addtime",
          align: "left",
          minWidth: 120,
          tree: true,
        },

        {
          title: this.$t("operation"),
          key: "explain",
          align: "center",
          width: 300,
          render: (h, { row }) => {
            let arr = [];
            if (row.status === 2) {
              arr.push(
                h(
                  "Button",
                  {
                    style: {
                      marginRight: "3px",
                      marginBottom: "3px",
                      color: "#2d8cf0",
                    },
                    props: {
                      size: "small",
                      type: "text",
                    },
                    on: {
                      click: () => {
                        this.downloadUrl(row);
                      },
                    },
                  },
                  this.$t("下载")
                )
              );
            }
            arr.push(
              h(
                "Button",
                {
                  style: {
                    marginRight: "3px",
                    marginBottom: "3px",
                    color: "#2d8cf0",
                  },
                  props: {
                    size: "small",
                    type: "text",
                  },
                  on: {
                    click: () => {
                      this.del(row);
                    },
                  },
                },
                this.$t("delete")
              )
            );

            return h("div", arr);
          },
        },
      ],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      addBase: {
        name: "",
        code: "",
        state: "",
        explain: "",
      },
      reqBase: {
        page: 1,
        page_size: 10,
      },
      states: [
        {
          value: 0,
          label: "禁用",
        },
        {
          value: 1,
          label: "启用",
        },
      ],
      modalTitle: true,
      ruleValidate: {
        name: [{ required: true, message: "请输入模块名", trigger: "blur" }],
        code: [
          { required: true, message: "请输入模块代码", trigger: "change" },
        ],
        explain: [{ required: true, message: "请输入说明", trigger: "blur" }],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
      },
    };
  },
  components: {},
  computed: {
    modelList() {
      return this.$store.state.authCenter.ModuleData;
    },
    getDownUrl() {
      let url =
        process.env.NODE_ENV === "development"
          ? config.baseUrl.dev
          : process.env.VUE_APP_BUILD === "production"
          ? config.baseUrl.pro
          : config.baseUrl.alp;
      return url;
    },
  },
  methods: {
      downloadUrl(row){
      let country_code = localStorage.getItem("country_code");
      let result =
      country_code === "xciot-prod-cnsz"
          ? "https://bms-api.xcthings.com"
          : country_code === "xciot-prod-hk"
          ? "https://bms-hk-api.xcthings.com"
          : country_code === "xciot-prod-us2"
          ? "https://bms-us-api.xcthings.com"
          : "https://bms-eu-api.xcthings.com";
      let url=`${result}/index.php/admin/download/download_log_file?code=${row.code}`
      window.open(url)
    },
    del(row) {
      console.log("rowrow", row);

      let vm = this;
      this.$Modal.confirm({
        title: this.$t("delete"),
        content:
          this.$t("isdelete") + " " + row.file_url + " " + this.$t("ma") + "？",
        loading: true,
        onOk: function () {
          let _this = this;
          del_download({ code: row.code }).then((res) => {
            let msg = res.errorMsg;
            if (res.result === 0) {
              let msg = res.errorMsg;
              vm.$Message.success(msg);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        },
      });
    },
    handleLoadData(item, callback) {
      console.log("11111");
      const vm = this;
      let callbak = (res) => {
        if (res.result === 0) {
          let data = res.body.list || [];
          for (let i in data) {
            let list = data[i];
            if (list.has_child === 1) {
              list._loading = false;
              list.children = [];
              list.parent_code = item.area_code;
              list.parent_name = item.area_name;
            }
          }
          callback(data);
        } else {
        }
      };
      area_list({
        page_size: -1,
        page: 1,
        parent_code: item.area_code,
        all: 1,
        // project_code:vm.projectCode,
        // parent_code:item.cate_code
      })
        .then((res) => {
          callbak(res);
        })
        .catch((err) => {
          // this.tableLoading=false;
        });
    },
    init() {
      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 初始化数据
     */
    getData() {
      this.form_filter.country_code = this.form_filter.country_code
        ? this.form_filter.country_code
        : localStorage.getItem("country_code");
      this.tableData.splice(0);
      this.tableLoading = true;
      const vm = this;
      let callbak = (res) => {
        this.tableLoading = false;
        if (res.result === 0) {
          let data = res.body.list || [];
          console.log("datadata", data);
          for (let i in data) {
            let list = data[i];
            if (list.has_child == 1) {
              // console.log(Vue.version)
              list._loading = false;
              list.parent_code = "0";
              (list.parent_name = this.$t("nodata")), (list.children = []);
            }
            console.log(list);
            vm.tableData.push(list);
          }
          console.log(vm.tableData);
          vm.tabletotallen = res.body.total;
        } else {
          vm.tableData = [];
          this.$Message.error(res.errorMsg);
        }
      };
      download_data(this.reqBase)
        .then((res) => {
          console.log("获取下载记录");
          callbak(res);
        })
        .catch((err) => {
          this.tableLoading = false;
        });
    },
    /**
     * 翻页
     */
    pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },
    /**
     * 筛选
     */
    showSearchParel() {
      this.$refs.search.expandPanel();
    },
    // download_life({ id: row.id })

    // let vm = this;
    // let config = {
    //   loading: true,
    //   width: 500,
    //   render: (h) => {
    //     return h("div", [
    //       h(
    //         "div",
    //         { style: { display: "flex", justifyContent: "space-between" } },
    //         [
    //           h(
    //             "h3",
    //             { style: { width: "100%", paddingBottom: "5px" } },
    //             this.$t("areamenu.editarea")
    //           ),
    //           h("icon", {
    //             props: { type: "md-close", size: "16" },
    //             style: {
    //               cursor: "pointer",
    //             },
    //             on: {
    //               click: (evt) => {
    //                 vm.$Modal.remove();
    //               },
    //             },
    //           }),
    //         ]
    //       ),
    //       h("Divider", {
    //         style: {
    //           margin: "8px 0",
    //         },
    //       }),
    //       h(addCom, {
    //         ref: "addCom",
    //         props: {
    //           edit: true,
    //           $store: vm.$store,
    //           _vm: vm,
    //           setData: row,
    //         },
    //       }),
    //     ]);
    //   },
    //   onOk: function () {
    //     let _this = this;
    //     let obj = this.$refs.addCom;
    //     obj.checkForm().then((res) => {
    //       if (res) {
    //         let { area_name, desc, area_code } = obj.formModel;

    //         area_update({ area_name, desc, area_code, type: 1 }).then(
    //           (res) => {
    //             let msg = res.errorMsg;
    //             if (res.result === 0) {
    //               let msg = res.errorMsg;
    //               vm.$Message.success(msg);
    //               vm.$Modal.remove();
    //               vm.init();
    //             } else {
    //               vm.$Message.error(msg);
    //               _this.buttonLoading = false;
    //             }
    //           }
    //         );
    //       } else {
    //         _this.buttonLoading = false;
    //       }
    //     });
    //   },
    // };
    // this.$Modal.confirm(config);
      search() {
    console.log("12151151", this.form_filter);
    localStorage.setItem("country_code", this.form_filter.country_code);
    this.init();
  },
  reset() {
    this.form_filter = {
      cate_name: null,
      country_code: localStorage.getItem("country_code")?localStorage.getItem("country_code"):"xciot-prod-cnsz",
    };
    this.search();
  },
  },


  mounted() {
    this.$set(this.reqBase, "project_code", this.$store.state.user.projectCode);
     setTimeout(() => {
    this.init();
  }, 1000);
  },
  created() {},
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style scoped>
.btnFormItem /deep/ .ivu-form-item-content {
  margin-top: 30px;
}
.searchForm /deep/ .ivu-form-item {
  margin-bottom: 5px;
}
</style>
